import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const DisenrollmentCategoriesRedux = createActions(
  {},
  {
    prefix: 'DISENROLLMENT_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = DisenrollmentCategoriesRedux
export const DisenrollmentCategoriesTypes = Types
export default Creators

export const INITIAL_STATE = createState({},
  { get: true })

export const reducer = createReducer(
  INITIAL_STATE, {
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/DisenrollmentCategoriesRedux.js